import {FC} from 'react';
import clsx from 'clsx';

import Button from '~/common/Button';
import {ButtonPayload} from '~/services/hot-api/notifications';

import s from './styles.module.scss';

interface ActionButtonProps {
  payload: ButtonPayload;
  onAction?: (url: string) => void;
  variant?: 'normal' | 'light';
}

const NotifcationActionsMap = {
  edit_promo: {
    label: 'Edit Promo',
    callback: (url: string) => {
      window.location.href = url;
    },
  },
  charge_balance: {
    label: 'Charge Balance',
    callback: (url: string) => {
      window.location.href = url;
    },
  },
  pay_promo: {
    label: 'Pay Promo',
    callback: (url: string) => {
      window.location.href = url;
    },
  },
};

const ActionButton: FC<ActionButtonProps> = ({payload, onAction, variant}) => {
  const buttonData = NotifcationActionsMap[payload.label];

  const handleButtonClick = async () => {
    if (onAction) {
      await onAction(payload.url);
    }
    buttonData.callback(payload.url);
  };

  if (!buttonData) {
    return null;
  }

  const buttonVariant = variant === 'light' ? 'outline' : 'normal';

  const classNames = clsx(s['action-button'], {
    [s['action-button--light']]: variant === 'light',
  });

  return (
    <Button className={classNames} variant={buttonVariant} onClick={handleButtonClick}>
      {buttonData.label}
    </Button>
  );
};

export default ActionButton;
